/*
 * Jellice free-gift v5 (mask-aware: never duplicates a mask from any source; checkout gate; class-driven empty state: cart is validated before checkout ever loads)
 * - Auto-adds ONE free High Absorption Mask whenever the cart has any real
 *   (non-gift) item. This includes a mask-only cart: buying just a mask still
 *   earns a second, free mask (buy 1 get 1). Removes the gift when the cart has
 *   no real item; caps the gift at qty 1. Loop-guarded so it never double-adds.
 * - Renders the gift in the cart DRAWER and on the standalone /cart page
 *   (fixes prefilled-cart permalink emails, which land straight on /cart).
 * - Makes add-to-cart open the cart drawer site-wide and wires the header cart
 *   icon to the drawer, with safe fallbacks if the theme's drawer JS failed.
 * The 100%-off itself comes from the automatic "Free High Absorption Mask on
 * all orders" discount (Buy any product incl. the Mask, Get 1 Mask free).
 */
(function () {
  var GIFT_VARIANT_ID = 49188459479359;
  var GIFT_PRODUCT_ID = 9555372671295;
  var GIFT_NAME = 'High Absorption Mask';
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var syncing = false;
  var queued = false;

  /* ---------- styles (brand: lavender #c8afd1, deep purple #4d425a) ---------- */
  function ensureStyles() {
    if (document.getElementById('jfg-style')) return;
    var s = document.createElement('style');
    s.id = 'jfg-style';
    s.textContent =
      '.jfg-msg{margin:4px 0 22px;padding:13px 18px;border-radius:4px;background:rgba(200,175,209,.16);border:1px solid rgba(200,175,209,.55);color:#4d425a;font-family:var(--font-body-family,sans-serif);font-size:14px;line-height:1.5;text-align:center;letter-spacing:.02em}' +
      '.jfg-msg strong{font-weight:700}' +
      '#CartDrawer .jfg-msg{margin:10px 16px 4px;font-size:13px;padding:11px 14px}' +
      '@media(max-width:600px){.jfg-msg{font-size:13px;padding:11px 14px}}';
    document.head.appendChild(s);
  }

  /* ---------- drawer helpers (independent of theme JS having bound) ---------- */
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function openDrawer() {
    var d = drawerEl();
    if (!d) return false;
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  }
  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
  function wireDrawer() {
    var d = drawerEl();
    if (!d) return;
    if (typeof d.close !== 'function') d.close = closeDrawer;
    if (typeof d.open !== 'function') d.open = function () { openDrawer(); };
    var ov = document.getElementById('CartDrawer-Overlay');
    if (ov && !ov.dataset.jfgWired) { ov.dataset.jfgWired = '1'; ov.addEventListener('click', closeDrawer); }
    var links = document.querySelectorAll('#cart-icon-bubble, header a[href*="/cart"], .header a[href*="/cart"], .header__icons a[href*="/cart"]');
    links.forEach(function (a) {
      if (a.dataset.jfgWired) return;
      a.dataset.jfgWired = '1';
      a.addEventListener('click', function (e) {
        if (!drawerEl()) return; // no drawer -> normal link
        e.preventDefault();
        openDrawer();
      });
    });
  }

  /* ---------- cart api ---------- */
  function getCart() {
    return fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function isGiftLine(it) {
    return !!(it.properties && it.properties._free_gift === 'true');
  }
  // Any real (non-gift) line earns the free mask, including a lone paid mask.
  function qualifies(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isGiftLine(cart.items[i])) return true;
    }
    return false;
  }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftLine(it)) return it;
    }
    return null;
  }

  /* ---------- section rendering (drawer + icon + the /cart page) ----------
   * The /cart page sections are named `cart-items` / `cart-footer` in this
   * theme's template; the Section Rendering API needs those exact ids, read
   * from each element's data-id. (Requesting "main-cart-items" returns nothing,
   * which is why the gift never used to show on the standalone /cart page.) */
  function cartPageTargets() {
    var t = [];
    var mi = document.getElementById('main-cart-items');
    if (mi) t.push({ sid: mi.getAttribute('data-id') || 'cart-items', dom: 'main-cart-items' });
    var mf = document.getElementById('main-cart-footer');
    if (mf) t.push({ sid: mf.getAttribute('data-id') || 'cart-footer', dom: 'main-cart-footer' });
    return t;
  }
  function sectionsToRender() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    cartPageTargets().forEach(function (t) { ids.push(t.sid); });
    return ids.join(',');
  }
  function innerHTMLFrom(html, selector) {
    try { var d = new DOMParser().parseFromString(html, 'text/html'); var el = d.querySelector(selector); return el ? el.innerHTML : null; } catch (e) { return null; }
  }
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var cd = document.getElementById('CartDrawer');
      if (cd) { var h = innerHTMLFrom(sections['cart-drawer'], '#CartDrawer'); if (h != null) cd.innerHTML = h; }
    }
    if (sections['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      if (b) { var hb = innerHTMLFrom(sections['cart-icon-bubble'], '.shopify-section'); if (hb != null) b.innerHTML = hb; }
    }
    cartPageTargets().forEach(function (t) {
      var html = sections[t.sid];
      if (html == null) return;
      var el = document.getElementById(t.dom);
      if (!el) return;
      var frag = innerHTMLFrom(html, '.js-contents');
      var tgt = el.querySelector('.js-contents');
      if (frag != null && tgt) tgt.innerHTML = frag;
      else if (frag != null) el.innerHTML = frag;
    });
    wireDrawer(); // overlay may have been replaced -> rebind
  }
  function post(url, body) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(rootUrl + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function addGift() { return post('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { '_free_gift': 'true' } }] }); }
  function setGiftQty(qty, key) { return post('cart/change.js', { id: key || String(GIFT_VARIANT_ID), quantity: qty }); }

  /* ---------- progress message ---------- */
  function renderMessage(cart) {
    ensureStyles();
    var dEl = drawerEl();
    if (dEl && cart) dEl.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelectorAll('.jfg-msg').forEach(function (n) { n.remove(); });
    if (!qualifies(cart)) return;
    var text = '🎁 Your <strong>FREE ' + GIFT_NAME + '</strong> has been added to your cart.';
    var card = document.createElement('div');
    card.className = 'jfg-msg jfg-msg--unlocked';
    card.innerHTML = '<div>' + text + '</div>';
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) {
      var head = inner.querySelector('.drawer__header');
      if (head && head.nextSibling) inner.insertBefore(card.cloneNode(true), head.nextSibling);
      else inner.insertBefore(card.cloneNode(true), inner.firstChild);
    }
    var mi = document.getElementById('main-cart-items');
    if (mi) {
      var jc = mi.querySelector('.js-contents');
      mi.insertBefore(card, jc || mi.firstChild);
    }
  }

  /* ---------- gift sync (loop-guarded) ---------- */
  function sync() {
    if (syncing) { queued = true; return Promise.resolve(); }
    syncing = true;
    return getCart().then(function (cart) {
      /* v5 core: decide by what is REALLY in the cart, not by our own tag.
         - A non-gift mask (e.g. from a Buy It Now / email cart link) already serves as
           the free mask (the automatic discount zeroes one mask however it arrived),
           so we must never add a second one, and we remove our own duplicate if the
           two ever coexist (this also auto-heals previously affected carts).
         - Mask-only carts: the customer's mask is a purchase, so they still get the
           promised bonus mask on top. */
      var g = giftLine(cart);
      var paidMask = 0, others = false;
      cart.items.forEach(function (it) {
        var isG = isGiftLine(it);
        if (it.product_id === GIFT_PRODUCT_ID) { if (!isG) paidMask += it.quantity; }
        else if (!isG) { others = true; }
      });
      var wantGift = others ? (paidMask === 0) : (paidMask >= 1);
      if (wantGift && !g) {
        return addGift().then(function (res) { applySections(res.sections); });
      } else if (!wantGift && g) {
        return setGiftQty(0, g.key).then(function (res) { applySections(res.sections); });
      } else if (g && g.quantity > 1) {
        return setGiftQty(1, g.key).then(function (res) { applySections(res.sections); });
      }
      return null;
    }).then(function () { return getCart(); })
      .then(function (cart) { renderMessage(cart); })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (queued) { queued = false; return sync(); }
      });
  }

  /* ---------- intercept ALL add-to-cart forms -> AJAX + open drawer ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!drawerEl()) return; // no drawer on page -> keep native behavior
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fd.append('sections', sectionsToRender());
    fd.append('sections_url', window.location.pathname);
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok || res.body.status) {
          alert(res.body.description || res.body.message || 'Could not add to cart.');
          return;
        }
        applySections(res.body.sections);
        openDrawer();
        setTimeout(sync, 60); // gift check after the user's add
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit(); // network problem -> native fallback
      });
  }, true);

  /* ---------- react to the theme's own cart mutations ---------- */
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) ? arguments[0].url : ('' + arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (!syncing && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(sync, 80); }).catch(function () {});
      }
      return p;
    };
  }


  /* ---------- checkout gate: never leave with an unvalidated cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn) return;
    if (btn.dataset.jfgGo === '1') { delete btn.dataset.jfgGo; return; } // validated pass-through
    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    sync()                                  // authoritative: removes an orphaned gift, adds a missing one
      .then(getCart)
      .then(function (cart) {
        btn.disabled = false;
        if (!cart || cart.item_count === 0) return; // cart emptied -> stay, drawer shows empty state
        window.location.href = rootUrl.replace(/\/$/, '') + '/checkout';
      })
      .catch(function () {                   // never trap the customer: fall through to checkout
        btn.disabled = false;
        window.location.href = '/checkout';
      });
  }, true);

  function init() { ensureStyles(); wireDrawer(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
